import BidsDetail from './BidsDetail';
import BidsHeader from './BidsHeader';
import BidsSide from './BidsSide';
import BidsTable from './BidsTable';
import BidsFilter from './BidsFilter';
import BidsCards from './BidsCards';
import BidsCardsSide from './BidsCardsSide';

//TODO: need to refactor the entire Bids module structure
export {
  BidsDetail,
  BidsHeader,
  BidsSide,
  BidsTable,
  BidsFilter,
  BidsCards,
  BidsCardsSide,
};



// WEBPACK FOOTER //
// ./src/components/admin/Bids/index.js